module.exports = __webpack_public_path__ + "img/open-banking.9b560cd0.svg";